import { create } from 'zustand';
import type { LoanRecord } from '~/types/loans';

interface LoansState {
    loans: LoanRecord[];
    loading: boolean;
    totalItems: number;
    setLoans: (loans: LoanRecord[], totalItems: number) => void;
    setLoading: (loading: boolean) => void;
}

let loanDataReseter: () => void;

const initialState = {
    loans: [],
    loading: false,
    totalItems: 0,
};

export const useLoansStore = create<LoansState>((set) => {
    loanDataReseter = () => set(initialState);

    return {
        ...initialState,
        setLoans: (loans, totalItems) => set({ loans, totalItems }),
        setLoading: (loading) => set({ loading }),
    };
});
